import { Button, Card, Flex, Radio, Space } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { GroupContent } from './GroupContent';

export const RuleGroupEditor = ({
  group,
  level = 0,
  ruleFields,
  onChange,
  onRemove,
  showFieldErrors = false,
  validateGroup,
}) => {
  const handleAddRule = () => {
    onChange({
      ...group,
      rules: [
        ...(group.rules || []),
        {
          field: undefined,
          operator: undefined,
          value: undefined,
        },
      ],
    });
  };

  const handleRemoveRule = (index) => {
    onChange({
      ...group,
      rules: (group.rules || []).filter((_, i) => i !== index),
    });
  };

  const handleRuleChange = (index, updatedRule) => {
    const newRules = [...(group.rules || [])];
    newRules[index] = updatedRule;
    onChange({
      ...group,
      rules: newRules,
    });
  };

  const handleAddGroup = () => {
    onChange({
      ...group,
      children: [
        ...(group.children || []),
        {
          operator: 'and',
          rules: [],
          children: [],
        },
      ],
    });
  };

  const handleRemoveGroup = (index) => {
    onChange({
      ...group,
      children: (group.children || []).filter((_, i) => i !== index),
    });
  };

  const handleGroupChange = (index, updatedGroup) => {
    const newChildren = [...(group.children || [])];
    newChildren[index] = updatedGroup;
    onChange({
      ...group,
      children: newChildren,
    });
  };

  const groupHasError = showFieldErrors && validateGroup && !validateGroup(group);

  // Contenido común del grupo
  const groupContent = (
    <GroupContent
      group={group}
      level={level}
      ruleFields={ruleFields}
      handleRemoveRule={handleRemoveRule}
      handleRuleChange={handleRuleChange}
      handleGroupChange={handleGroupChange}
      handleRemoveGroup={handleRemoveGroup}
      handleAddRule={handleAddRule}
      handleAddGroup={handleAddGroup}
      showFieldErrors={showFieldErrors}
      validateGroup={validateGroup}
      groupHasError={groupHasError}
    />
  );

  // Nivel raíz: solo contenido sin Card ni header
  if (level === 0) {
    return (
      <Flex vertical gap='small'>
        {groupContent}
      </Flex>
    );
  }

  // Niveles anidados: Card con header del operador
  return (
    <Card
      size='small'
      style={{
        marginTop: -1,
        borderColor: '#d9d9d9',
        backgroundColor: 'transparent',
      }}
      styles={{
        body: { paddingInline: '3%' },
      }}
    >
      <Flex vertical gap='small'>
        <Flex justify='space-between' align='center' wrap='wrap' gap='small'>
          <Flex align='center' gap='small' flex={1}>
            <Radio.Group
              value={group.operator}
              onChange={(e) => onChange({ ...group, operator: e.target.value })}
              size='small'
            >
              <Space direction='vertical' size='small'>
                <Radio value='and'>Se deben cumplir todas las condiciones</Radio>
                <Radio value='or'>Se debe cumplir al menos una condición</Radio>
                <Radio value='not'>Se niega la condición</Radio>
              </Space>
            </Radio.Group>
          </Flex>
          {onRemove && (
            <Button
              type='text'
              danger
              icon={<DeleteOutlined />}
              onClick={onRemove}
              size='small'
            />
          )}
        </Flex>
        {groupContent}
      </Flex>
    </Card>
  );
};
